<template>
    <c-dialog ref="dialog" title="品牌库" width="900" @resolve="resolve">
        <m-search ref="search" @search="search">
            <c-form ref="form" inline>
                <c-form-item type="input" label="品牌名称" name="brand_name"></c-form-item>
            </c-form>
        </m-search>

        <c-table ref="table" height="400">

            <c-table-column
                    type="selector"
                    :multiple="!!multiple"
            ></c-table-column>

            <c-table-column
                    label="logo"
                    width="100"
            >
                <template v-slot="{data}">
                    <c-image :src="data.logo" size="50"></c-image>
                </template>
            </c-table-column>

            <c-table-column
                    label="品牌名称"
                    name="brand_name"
            ></c-table-column>

            <c-table-column
                    label="品牌介绍"
                    name="remark"
                    width="200"
            ></c-table-column>

        </c-table>
    </c-dialog>
</template>

<script>
    export default {
        props: {
            multiple: Boolean
        },

        methods: {
            search(data) {
                this.$refs.table.load({
                    url: '/product_brand/list',
                    data
                });
            },

            open() {
                this.$refs.form.clear();
                this.$refs.search.search();
                this.$refs.dialog.open();
            },

            resolve(stop) {
                var data = this.$refs.table.getRow('selected');
                if (!data.length) {
                    stop();
                    this.$message({
                        text: '请选择品牌'
                    });
                    return;
                }
                this.$emit('resolve', Array.from(data, item => item.data));
            }
        }
    }
</script>